/* tslint:disable */
/* eslint-disable */
/**
 * Berichtsmanagement
 * Berichte verwalten
 *
 * The version of the OpenAPI document: 1.0.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Eintrag } from './Eintrag';
import {
    EintragFromJSON,
    EintragFromJSONTyped,
    EintragToJSON,
} from './Eintrag';
import type { RechnungsdatenAorv } from './RechnungsdatenAorv';
import {
    RechnungsdatenAorvFromJSON,
    RechnungsdatenAorvFromJSONTyped,
    RechnungsdatenAorvToJSON,
} from './RechnungsdatenAorv';
import type { RechnungsdatenDbbg } from './RechnungsdatenDbbg';
import {
    RechnungsdatenDbbgFromJSON,
    RechnungsdatenDbbgFromJSONTyped,
    RechnungsdatenDbbgToJSON,
} from './RechnungsdatenDbbg';
import type { RechnungsdatenOebbArge } from './RechnungsdatenOebbArge';
import {
    RechnungsdatenOebbArgeFromJSON,
    RechnungsdatenOebbArgeFromJSONTyped,
    RechnungsdatenOebbArgeToJSON,
} from './RechnungsdatenOebbArge';

/**
 * 
 * @export
 * @interface BerichtMitRechnungsdaten
 */
export interface BerichtMitRechnungsdaten {
    /**
     * 
     * @type {Eintrag}
     * @memberof BerichtMitRechnungsdaten
     */
    bericht: Eintrag;
    /**
     * 
     * @type {RechnungsdatenOebbArge}
     * @memberof BerichtMitRechnungsdaten
     */
    rechnungsdatenOebbArge?: RechnungsdatenOebbArge;
    /**
     * 
     * @type {RechnungsdatenDbbg}
     * @memberof BerichtMitRechnungsdaten
     */
    rechnungsdatenDbbg?: RechnungsdatenDbbg;
    /**
     * 
     * @type {RechnungsdatenAorv}
     * @memberof BerichtMitRechnungsdaten
     */
    rechnungsdatenAorv?: RechnungsdatenAorv;
    /**
     * 
     * @type {boolean}
     * @memberof BerichtMitRechnungsdaten
     */
    hatRechnungsvorlage?: boolean;
}

/**
 * Check if a given object implements the BerichtMitRechnungsdaten interface.
 */
export function instanceOfBerichtMitRechnungsdaten(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "bericht" in value;

    return isInstance;
}

export function BerichtMitRechnungsdatenFromJSON(json: any): BerichtMitRechnungsdaten {
    return BerichtMitRechnungsdatenFromJSONTyped(json, false);
}

export function BerichtMitRechnungsdatenFromJSONTyped(json: any, ignoreDiscriminator: boolean): BerichtMitRechnungsdaten {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bericht': EintragFromJSON(json['Bericht']),
        'rechnungsdatenOebbArge': !exists(json, 'RechnungsdatenOebbArge') ? undefined : RechnungsdatenOebbArgeFromJSON(json['RechnungsdatenOebbArge']),
        'rechnungsdatenDbbg': !exists(json, 'RechnungsdatenDbbg') ? undefined : RechnungsdatenDbbgFromJSON(json['RechnungsdatenDbbg']),
        'rechnungsdatenAorv': !exists(json, 'RechnungsdatenAorv') ? undefined : RechnungsdatenAorvFromJSON(json['RechnungsdatenAorv']),
        'hatRechnungsvorlage': !exists(json, 'HatRechnungsvorlage') ? undefined : json['HatRechnungsvorlage'],
    };
}

export function BerichtMitRechnungsdatenToJSON(value?: BerichtMitRechnungsdaten | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Bericht': EintragToJSON(value.bericht),
        'RechnungsdatenOebbArge': RechnungsdatenOebbArgeToJSON(value.rechnungsdatenOebbArge),
        'RechnungsdatenDbbg': RechnungsdatenDbbgToJSON(value.rechnungsdatenDbbg),
        'RechnungsdatenAorv': RechnungsdatenAorvToJSON(value.rechnungsdatenAorv),
        'HatRechnungsvorlage': value.hatRechnungsvorlage,
    };
}

